import React, { useState } from 'react';
import SideBar from "../components/sidebar"
import { AppHeader } from "../components/header"
import { ChildrenCompProps } from "../../types";
import "../../scss/inapp.scss"
import { useWindowSize } from "../../hooks/useWindowSize";
export const InAppTemplate: React.FC<ChildrenCompProps> = (props) => {
    const screenResolution: any = useWindowSize();
    const { childComponent,isWide, pageHeadingTitle, noSideBar, showMainPageHeading, mainPageHeading,noStores } = props;

    return (
        <div className="inapp-wrap">

            {(screenResolution?.width >= 1025 && !noSideBar) &&
                <SideBar noStores={noStores} />
            }
            <div className={isWide?"page-main-content full_width": "page-main-content"}>
                {/* {(screenResolution?.width >= 769 && !noSideBar) &&
                    <SideBar />
                } */}
                <AppHeader isWide={isWide} noStores={noStores} mainPageHeading={mainPageHeading} showMainPageHeading={showMainPageHeading} pageHeadingTitle={pageHeadingTitle} />
                <div className={screenResolution?.width >= 1025 ? 
                        `inapp-container ${noSideBar ? "no-stores-wrap" : ""}` :
                         `inapp-container mobile ${noSideBar ? "no-stores-wrap" : ""}`}>
                    {childComponent}
                </div>
            </div>
        </div>
    )
}